export { default } from "./CustomersPopup.jsx"
